export interface Testimonial {
  id: number;
  name: string;
  role: string;
  avatarUrl: string;
  rating: number;
  title: string;
  content: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: "Carlos Mendes",
    role: "Comprador Frequente",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20man%20with%20warm%20genuine%20smile%2C%20outdoor%20natural%20light%20with%20trees%20blurred%20behind%2C%20casual%20denim%20shirt%2C%20friendly%20approachable%20expression%2C%20lifestyle%20portrait%20photography%2C%20warm%20sunlight%20on%20face&width=80&height=80&seq=test-v2-avatar-01&orientation=squarish",
    rating: 5,
    title: "Mudou completamente a minha experiência",
    content: "O CSSBuy Spreadsheet transformou a forma como faço compras na China. Consigo comparar preços e acompanhar todos os meus pedidos num só lugar. Recomendo a todos que compram regularmente.",
  },
  {
    id: 2,
    name: "Ana Silva",
    role: "Revendedora",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20woman%20with%20confident%20expression%2C%20modern%20office%20background%20with%20soft%20bokeh%2C%20elegant%20white%20blouse%2C%20warm%20indoor%20lighting%2C%20business%20portrait%20style%2C%20friendly%20yet%20professional%20look&width=80&height=80&seq=test-v2-avatar-02&orientation=squarish",
    rating: 5,
    title: "Essencial para o meu negócio",
    content: "Como revendedora, preciso de eficiência. Com o CSSBuy Spreadsheet, organizo dezenas de encomendas sem me perder. A funcionalidade de tracking é fantástica e poupa-me horas de trabalho.",
  },
  {
    id: 3,
    name: "Pedro Oliveira",
    role: "Entusiasta de Moda",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20stylish%20young%20man%20with%20tinted%20glasses%2C%20urban%20city%20street%20background%20blurred%2C%20cool%20confident%20expression%2C%20fashion%20forward%20look%2C%20editorial%20portrait%20style%2C%20natural%20daylight%2C%20creative%20vibe&width=80&height=80&seq=test-v2-avatar-03&orientation=squarish",
    rating: 5,
    title: "Simplesmente o melhor para compras",
    content: "Já experimentei vários agentes de compras, mas nenhum oferece a organização que o CSSBuy Spreadsheet proporciona. As tabelas de custo são transparentes e fáceis de entender.",
  },
  {
    id: 4,
    name: "Mariana Costa",
    role: "Compradora Iniciante",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20woman%20with%20warm%20smile%2C%20cozy%20cafe%20background%20with%20warm%20interior%20lighting%2C%20casual%20knit%20sweater%2C%20friendly%20genuine%20expression%2C%20lifestyle%20portrait%20photography%2C%20relaxed%20happy%20mood&width=80&height=80&seq=test-v2-avatar-04&orientation=squarish",
    rating: 5,
    title: "Perfeito para iniciantes",
    content: "Comecei a comprar da China recentemente e estava perdida. O guia do CSSBuy Spreadsheet ensinou-me tudo passo a passo. Agora compro com confiança e economizo muito dinheiro.",
  },
  {
    id: 5,
    name: "Rafael Santos",
    role: "Empresário",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20man%20in%20his%2030s%20with%20confident%20smile%2C%20modern%20minimalist%20office%20background%2C%20navy%20blazer%2C%20trustworthy%20professional%20expression%2C%20executive%20portrait%20style%2C%20clean%20corporate%20photography&width=80&height=80&seq=test-v2-avatar-05&orientation=squarish",
    rating: 5,
    title: "A melhor ferramenta de organização",
    content: "Uso o CSSBuy Spreadsheet para gerir compras em grande volume. A capacidade de acompanhar múltiplas encomendas simultaneamente é revolucionária. Nunca mais perdi um pedido.",
  },
  {
    id: 6,
    name: "Sofia Almeida",
    role: "Designer de Moda",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20creative%20woman%20with%20artistic%20look%2C%20design%20studio%20background%20with%20fabric%20swatches%2C%20colorful%20scarf%2C%20creative%20confident%20expression%2C%20artistic%20portrait%20photography%2C%20warm%20creative%20lighting&width=80&height=80&seq=test-v2-avatar-06&orientation=squarish",
    rating: 5,
    title: "Indispensável para designers",
    content: "Como designer, preciso de amostras de vários fornecedores. O CSSBuy Spreadsheet permite-me organizar todas as minhas encomendas de forma visual e intuitiva. É uma ferramenta que uso diariamente.",
  },
];